
import Strapi from "strapi-sdk-js"

const API_URL = process.env.REACT_APP_STRAPI_URL || 'http://192.168.88.38:1337';

export async function fetchInfo(locale) {
  const response = await fetch(`${API_URL}/api/information?populate=*&locale=${locale}`);
  const data = await response.json();
  return data.data;
}

export async function fetchDirectors(locale) {
  const response = await fetch(`${API_URL}/api/authors?populate=*&locale=${locale}`);
  const data = await response.json();
  return data.data;
}

export async function fetchNavBar(locale) {
  const response = await fetch(`${API_URL}/api/nav-bars?locale=${locale}&sort=order`);
  const data = await response.json();
  //console.log(data.data)
  return data.data;
}

export async function fetchNews(locale) {
  const response = await fetch(`${API_URL}/api/new?populate=*&sort=date:desc&locale=${locale}`);
  const data = await response.json();
  return data.data;
}

export async function fetchNewsById(id, locale) {
  const response = await fetch(`${API_URL}/api/new/${id}?populate=*&locale=${locale}`);
  const data = await response.json();
  return data.data;
}

export async function fetchProduct(locale, first, second, page, pageSize, search) {
  let firstQuery = first ? `&filters[first_level_sort][documentId][$eq]=${first}` : '';
  let secondQuery = second ? `&filters[second_level_sort][documentId][$eq]=${second}` : '';
  let pageQuery = page ? `&pagination[page]=${page}` : '';
  let paginationQuery = page ? `&pagination[withCount]=true` : '';
  let pageSizeQuery = pageSize ? `&pagination[pageSize]=${pageSize}` : '';
  let searchQuery = search 
    ? `&filters[$or][0][name][$containsi]=${search}&filters[$or][1][nameShort][$containsi]=${search}`
    : '';
  const response = await fetch(`${API_URL}/api/products?${searchQuery}${firstQuery}${secondQuery}${pageQuery}${pageSizeQuery}${paginationQuery}&populate=*&locale=${locale}`);
  const data = await response.json();
  //console.log('fetch product: ' + data.data)
  return data;
}

// export async function fetchProductSortFirst(locale, first, page, pageSize, search) {
//  const response = await fetch(`${API_URL}/api/products?filters[first_level_sort][title][$eq]=${first}&filters[name][$containsi]=${search}&?pagination[page]=${page}&?pagination[pageSize]=${pageSize}&pagination[withCount]=true&populate=*&?locale=${locale}`)
//   //const response = await fetch(`${API_URL}/api/products?filters[first_level_sort][title][$eq]=${first}&filters[second_level_sort][title][$eq]=${second}&populate=*&?locale=${locale}`)
//   const data = await response.json();
//   console.log(data.data)
//   return data;
// }

// export async function fetchProductSort(locale, first, second, page, pageSize, search) {
// const response = await fetch(`${API_URL}/api/products?filters[first_level_sort][title][$eq]=${first}&filters[second_level_sort][title][$eq]=${second}&filters[name][$containsi]=${search}&?pagination[page]=${page}&pagination[pageSize]=${pageSize}&pagination[withCount]=true&populate=*&?locale=${locale}`)
//   const data = await response.json();
//   console.log(data.data)
//   return data;
// }


export async function fetchProductById(id, locale) {
  const response = await fetch(`${API_URL}/api/products/${id}?populate[image]=true&populate[first_level_sort]=true&populate[second_level_sort]=true&populate[specifications][populate][1]=rows&populate[docs]=true&locale=${locale}`);
  const data = await response.json();
  return data.data;
}

export async function fetchSpecifications(id, locale) {
  const response = await fetch(`${API_URL}/api/specifications/${id}?populate[table][populate][rows]=true&locale=${locale}`);
  const data = await response.json();
  //console.log(data.data)
  return data.data;
}

export async function fetchMainPage(locale) {
  const response = await fetch(`${API_URL}/api/main-pages?populate=*&locale=${locale}`);
  const data = await response.json();
  return data.data;
}

export async function fetchMeteo(locale) {
  const response = await fetch(`${API_URL}/api/meteo?populate=*&locale=${locale}`);
  const data = await response.json();
  //console.log(data.data)
  return data.data;
}

export async function fetchMeteoList(locale) {
  const response = await fetch(`${API_URL}/api/meteo-lists?populate=*&locale=${locale}`);
  const data = await response.json();
  //console.log(data.data)
  return data.data;
}

export async function fetchSAWC(locale) {
  const response = await fetch(`${API_URL}/api/sawc?populate=*&locale=${locale}`);
  const data = await response.json();
  //console.log(data.data)
  return data.data;
}

export async function fetchSAWCList(locale) {
  const response = await fetch(`${API_URL}/api/sawc-lists?populate=*&locale=${locale}`);
  const data = await response.json();
  //console.log(data.data)
  return data.data;
}

export async function fetchFirstLevelSort(locale) {
  const response = await fetch(`${API_URL}/api/first-level-sorts?populate=*&locale=${locale}`);
  const data = await response.json();
  //console.log(data.data)
  return data.data;
}

export async function fetchSecondLevelSort(locale) {
  const response = await fetch(`${API_URL}/api/second-level-sorts?populate=*&locale=${locale}`);
  const data = await response.json();
  //console.log(data.data)
  return data.data;
}

export async function fetchCompanyFiles(locale) {
  const response = await fetch(`${API_URL}/api/company-files?populate=*&locale=${locale}`);
  const data = await response.json();
  //console.log(data.data)
  return data.data;
}
// export async function documentById(id) {
//   const strapi = new Strapi()
//   const response = await strapi.documents('api::products.docs').findOne({documentId: {id}})
//   const data = await response.json();
//   console.log(data.data)
//   return data.data;
// }
export async function fetchContractProduction(locale) {
  const response = await fetch(`${API_URL}/api/contract-production?populate=*&locale=${locale}`);
  const responseA = await fetch(`${API_URL}/api/contract-production-points?populate=*&locale=${locale}`);
  const data = await response.json();
  const dataA = await responseA.json();
  //console.log(data.data)
  //console.log(dataA.data)
  return {data: data.data, dataA: dataA.data};
}

export async function fetchContractProductionPoints(locale) {
  const response = await fetch(`${API_URL}/api/contract-production-points?populate=*&locale=${locale}`);
  const data = await response.json();
  //console.log(data.data)
  return data.data;
}


export async function fetchArticle(id, locale) {
  const response = await fetch(`${API_URL}/api/articles/${id}?populate=*`);
  const data = await response.json();
  return data.data;
}

export async function searchArticles(query, locale, page, pageSize) {
  let pageQuery = page ? `&pagination[page]=${page}` : '';
  let pageSizeQuery = pageSize ? `&pagination[pageSize]=${pageSize}` : '';
  const qs = encodeURIComponent(query || '');
  const url = `${API_URL}/api/search/search?q=${qs}${pageQuery}${pageSizeQuery}&pagination[withCount]=true${locale ? `&locale=${locale}` : ''}`;
  const response = await fetch(url);
  const data = await response.json();
  // endpoint may return data.data or raw array/object — normalize to caller-friendly shape
  return data;
}



